import { apiSlice } from './apiSlice.js'



export const exchangeSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getExchangeRates: builder.query({
      query: () => '/api/exchange-rates',
      keepUnusedDataFor: 86400,
    }),
  }),
});



export const { useGetExchangeRatesQuery } = exchangeSlice;